import { useLayoutEffect, useRef, useState } from 'react'

const MAX_PX = 20
const MIN_PX = 12

/**
 * Общий размер плашек-вариантов: самая широкая целиком влезает в ряд. Слово не переносим,
 * поэтому уменьшаем все плашки разом от 20px шагом 1px до 12px.
 */
export const useFitChips = (key: string) => {
  const ref = useRef<HTMLDivElement>(null)
  const [fontSize, setFontSize] = useState(MAX_PX)

  useLayoutEffect(() => {
    const row = ref.current
    if (!row) return
    const fit = () => {
      let size = MAX_PX
      for (; size > MIN_PX; size -= 1) {
        row.style.fontSize = `${size}px`
        const widest = Math.max(
          0,
          ...Array.from(row.children, (chip) => (chip as HTMLElement).offsetWidth),
        )
        if (widest <= row.clientWidth) break
      }
      row.style.fontSize = `${size}px`
      setFontSize(size)
    }
    fit()
    if (typeof ResizeObserver === 'undefined') return
    let width = row.clientWidth
    const observer = new ResizeObserver(() => {
      if (row.clientWidth !== width) {
        width = row.clientWidth
        fit()
      }
    })
    observer.observe(row)
    return () => observer.disconnect()
  }, [key])

  return { ref, fontSize }
}
